import classNames from 'classnames';
import { observer } from 'mobx-react';

import { DESKTOP_THRESHOLD } from '../../../config/constants';
import { useDelayedToggle } from '../../../hooks/useDelayedToggle';

import styles from './interactiveAnimationFTUE.module.scss';
import { InteractiveAnimationFTUERive } from './InteractiveAnimationFTUERive';
import { useInteractiveAnimationFTUE } from './useInteractiveAnimationFTUE';

export const InteractiveAnimationFTUEView = observer(() => {
  const { terminateOnboardingTourGuideFlow, onGuideEvent, showOnboarding, savedStep } = useInteractiveAnimationFTUE();

  const isViewShowed = useDelayedToggle(showOnboarding, 200);

  if (!isViewShowed) {
    return null;
  }

  const isDesktop = window.parent.innerWidth > DESKTOP_THRESHOLD;

  return (
    <div
      className={classNames({
        [styles.overlay]: true,
        [styles.fadeIn]: showOnboarding,
        [styles.fadeOut]: !showOnboarding,
      })}
    >
      <InteractiveAnimationFTUERive
        savedStep={savedStep || null}
        terminateTourGuideFlow={terminateOnboardingTourGuideFlow}
        viewType={isDesktop ? 'desktop' : 'mobile'}
        onGuideEvent={onGuideEvent}
      />
    </div>
  );
});
